import { Component, Input } from "@angular/core";

@Component({
    selector: "app-no-data",
    templateUrl: "./no-available-data.component.html",
    styleUrls: ["./no-available-data.component.css"],
    standalone: false
})
export class NoAvailableDataComponent {
  @Input() infoText: string;
  constructor() {}
}
